import { ModelEntityType } from '@upright/common/model/input/types';
import { getValueSetName } from '@upright/ui/untidy/redux/selectors';
import { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import { DownloadImageButton } from '../../../../impact-lens-profile/common/components/download-image-button';
import { Bounds } from '../../../../impact-lens-profile/common/layout/types';
import { useCarouselLayout } from '../../../../impact-lens-profile/context';
import { useNetImpactLensContext } from '../../common/use-net-impact-lens-context';
import { aggregateResultAreaLayout } from '../layout';
import { showSuggestFixes, SuggestFixes } from './suggest-fixes';

export function ActionsArea() {
  const context = useNetImpactLensContext();
  const valueSet = useSelector(getValueSetName);
  const layout = aggregateResultAreaLayout(useCarouselLayout(), valueSet);
  const area = layout.actionsBounds();
  const wrapperStyle = getWrapperStyle(area);

  const options = context?.options;

  const suggestFixes = !!options && showSuggestFixes(options);
  const isCompany = context?.data?.entity?.type === ModelEntityType.COMPANY;
  const companyId = context?.data?.entity?.id;

  const showDownloadButton = !options?.hideRenderViewButton;

  return (
    <div style={wrapperStyle}>
      {suggestFixes && isCompany && companyId && <SuggestFixes companyId={companyId} />}
      {showDownloadButton && <DownloadImageButton />}
    </div>
  );
}

function getWrapperStyle(area: Bounds & { narrowMode: boolean }) {
  const common: CSSProperties = {
    top: area.y1,
    left: area.x1,
    width: area.width,
    position: 'absolute',
    paddingRight: 20,
  };

  if (area.narrowMode) {
    const style: CSSProperties = {
      ...common,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    };
    return style;
  } else {
    const style: CSSProperties = {
      ...common,
      height: area.height,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'end',
      gap: 16,
    };
    return style;
  }
}
